import { create } from "zustand";
import type { Map as MLMap } from "maplibre-gl";

/**
 * The live MapLibre instance, reachable from anywhere.
 *
 * This was a React context provided by <MapView> and consumed by its children.
 * That broke the moment the sidebar was docked beside the map instead of
 * floating over it: the panels became siblings of the provider rather than
 * descendants, `useMap()` quietly returned null, and every fly-to in the app
 * became a no-op with nothing logged.
 *
 * A store has no such coupling — and unlike a ref through context, subscribers
 * re-render when the map finally exists rather than holding the null they saw
 * on first paint.
 */
interface MapState {
  map: MLMap | null;
  setMap: (map: MLMap | null) => void;
}

export const useMapStore = create<MapState>((set) => ({
  map: null,
  setMap: (map) => set({ map }),
}));

/** The live map, or null before the style has loaded. */
export const useMap = (): MLMap | null => useMapStore((s) => s.map);
